export { default } from './BoxDivider';
